var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSandclock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_sandclock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sandclock",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#005082",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,4 C6.45,4 6,4.45 6,5 L6.005,6.59 C6.005,6.855 6.11,7.105 6.295,7.295 L8,9 L6.295,10.715 C6.11,10.9 6.005,11.155 6.005,11.42 L6,13 C6,13.55 6.45,14 7,14 L11,14 C11.55,14 12,13.55 12,13 L12,11.42 C12,11.155 11.895,10.9 11.71,10.715 L10,9 L11.705,7.3 C11.895,7.11 12,6.855 12,6.59 L12,5 C12,4.45 11.55,4 11,4 L7,4 Z M11.1428571,11.5927273 L11.1428571,12.6060606 C11.1428571,12.8727273 10.9258929,13.0909091 10.6607143,13.0909091 L7.76785714,13.0909091 C7.50267857,13.0909091 7.28571429,12.8727273 7.28571429,12.6060606 L7.28571429,11.5927273 C7.28571429,11.4618182 7.33875,11.3406061 7.42553571,11.2484848 L9.21428571,9.45454545 L11.0030357,11.2533333 C11.0898214,11.3406061 11.1428571,11.4666667 11.1428571,11.5927273 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSandclock);
export default __webpack_public_path__ + "static/media/icon_sandclock.7c3814e7b9d937bc83a0e2b8636f3c33.svg";
export { ForwardRef as ReactComponent };